<template>
  <v-row align="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-card-text class="pt-0" :key="item + 'header2'">
        <v-row align="center" class="ma-0 pa-0">
          <v-col cols="2" class="pa-0">
          </v-col>
          <v-col cols="10" class="pa-0">
            <v-row align="center" class="ma-0 pa-0">
              <v-col class="pa-0" v-for="i in 13" :key="i">
                <v-sheet
                  :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                  dark
                  height="21"
                  :key="i"
                  tile
                  :class="i == 13 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                >
                  <span :class="year == getFY() && mm == i ? 'white--text select-none' : 'secondary--text select-none'">{{ getMonth(i, 'total') }}</span>
                </v-sheet>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="center" class="ma-0 pa-0">
          <v-col cols="2" class="pa-0">
            <v-toolbar flat height="21" color="transparent">
              <v-spacer></v-spacer>
              <v-btn dark small icon @click.stop.prevent="toggle(item, 0)">
                <v-icon v-if="checkToggle(item, 0)" :color="pColor(item)">mdi-menu-up</v-icon>
                <v-icon v-else :color="pColor(item)">mdi-menu-down</v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
          <v-col cols="10" class="pa-0">
            <v-row align="center" class="ma-0 pa-0">
              <v-col class="pa-0" v-for="i in 13" :key="i">
                <v-row align="center" class="ma-0 pa-0">
                  <v-col cols="6" class="pa-0" align="center">
                    <v-sheet
                      :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                      height="21"
                      :key="i"
                      tile
                      dark
                      :class="i == 13 ? 'b-L-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                    >
                      <span :class="year == getFY() && mm == i ? 'white--text select-none' : 'secondary--text select-none'">入</span>
                    </v-sheet>
                  </v-col>
                  <v-col cols="6" class="pa-0" align="center">
                    <v-sheet
                      :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                      height="21"
                      :key="i"
                      tile
                      dark
                      :class="i == 13 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                    >
                      <span :class="year == getFY() && mm == i ? 'white--text select-none' : 'secondary--text select-none'">退</span>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <template v-for="(metric, index) in headers">
          <v-row v-if="checkHide(item, metric.type) && metric.roles[getPrivilege(data)]" align="center" :class="metric.type == 'none' ? 'ma-0 pa-0' : 'ma-0 pa-0'" :key="index">
            <v-col cols="2" class="pa-0">
              <v-sheet color="transparent" tile :class="(headers.length - 1) == index ? 'b-L-GREY b-T-GREY b-B-GREY' : 'b-L-GREY b-T-GREY'" height="21">
                <template v-if="metric.type != 'header'">
                  <span :class="metric.type == 'none' ? 'pl-4 white--text select-none' : 'pl-4 select-none'">{{ metric.name + '（' + metric.sufix + '）' }}</span>
                </template>
                <template v-else>
                  <v-toolbar flat :color="pColor(item)" height="20">
                    <span class="white--text select-none">{{ metric.name }}</span>
                    <v-spacer></v-spacer>
                    <template v-if="checkExpand(item, metric.key)">
                      <v-btn dark small icon @click.stop.prevent="toggle(item, metric.key)">
                        <v-icon v-if="checkToggle(item, metric.key)">mdi-menu-up</v-icon>
                        <v-icon v-else>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                  </v-toolbar>
                </template>
              </v-sheet>
            </v-col>
            <v-col cols="10" class="pa-0">
              <v-row align="center" class="ma-0 pa-0">
                <v-col class="pa-0" v-for="i in 13" :key="i">
                  <v-row align="center" class="ma-0 pa-0">
                    <v-col cols="6" class="pa-0">
                      <v-sheet
                        :class="getBackgroundColor (mm, i, index, false)"
                        :color="checkValue (item, i, index, metric)"
                        height="21"
                        :key="i"
                        tile
                      >
                        <template v-if="i != 13">
                          <span
                            v-if="i != 13"
                            style="text-align: right; width: 100%;"
                            :class="metric.type == 'header' && year == getFY() && mm == i ? 'white--text pr-1 clickable' : 'pr-1 clickable'"
                            @click.stop="onValueSelect(item, i, index, 0, metric)"
                          >
                            {{ getStatus(item, i, metric, 0, 0) }}
                          </span>
                        </template>
                        <template v-else>
                          <span
                            style="text-align: right; width: 100%;"
                            class="pr-1 font-weight-bold select-none"
                          >
                            {{ getTotalStatus(item, metric, 0, 0) }}
                          </span>
                        </template>
                      </v-sheet>
                    </v-col>
                    <v-col cols="6" class="pa-0">
                      <v-sheet
                        :class="getBackgroundColor (mm, i, index, true)"
                        :color="checkValue (item, i, index, metric)"
                        height="21"
                        :key="i"
                        tile
                      >
                        <template v-if="i != 13">
                          <span
                            v-if="i != 13"
                            style="text-align: right; width: 100%;"
                            :class="metric.type == 'header' && year == getFY() && mm == i ? 'white--text pr-1 clickable' : 'pr-1 clickable'"
                            @click.stop="onValueSelect(item, i, index, 1, metric)"
                          >
                            {{ getStatus(item, i, metric, 1, 1) }}
                          </span>
                        </template>
                        <template v-else>
                          <span
                            style="text-align: right; width: 100%;"
                            class="pr-1 font-weight-bold select-none"
                          >
                            {{ getTotalStatus(item, metric, 1, 1) }}
                          </span>
                        </template>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
export default {
  computed: {
    ...mapGetters({
      data: 'auth/data'
    })
  },
  props: [ 'groups', 'item', 'year', 'compare', 'headers', 'expand', 'status', 'plans', 'inout', 'sColor' ],
  data () {
    return {
      mm: 0,
      exp: []
    }
  },
  watch: {
    groups () {
      this.createExpansions()
    }
  },
  created () {
    moment.tz.setDefault('Asia/Tokyo')
    var mm = moment().month()
    this.mm = mm > 2 ? mm - 2 : mm + 10
    this.createExpansions()
  },
  methods: {
    createExpansions () {
      this.exp = []
      if (!this.data || typeof this.data.groups === 'undefined') {
        return
      }
      if (this.getPrivilegesLevel(this.data) === 0) {
        Vue.set(this.exp, '*', JSON.parse(JSON.stringify(this.expand)))
        for (var index in this.groups) {
          if (this.groups[index].classroom) {
            Vue.set(this.exp, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
          }
        }
      } else if (this.getPrivilegesLevel(this.data) < 3) {
        Vue.set(this.exp, '*', JSON.parse(JSON.stringify(this.expand)))
        var keys = Object.keys(this.data.schools)
        for (index in this.groups) {
          for (var x in keys) {
            if (this.data.schools[keys[x]]) {
              if (this.groups[index].classroom) {
                if (this.groups[index].schools[keys[x]]) {
                  Vue.set(this.exp, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
                }
              }
            }
          }
        }
      } else {
        keys = Object.keys(this.data.groups)
        for (index in this.groups) {
          for (x in keys) {
            if (this.data.groups[keys[x]]) {
              if (this.groups[index].classroom) {
                if (this.groups[index].key === keys[x]) {
                  Vue.set(this.exp, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
                }
              }
            }
          }
        }
      }
    },
    pColor (group) {
      var color = 'primary'
      if (group !== '*') {
        var index = this.groups.findIndex(g => g.key === group)
        if (index !== -1) {
          if (typeof this.groups[index].color !== 'undefined') {
            return this.groups[index].color
          }
        }
      }
      return color
    },
    getBackgroundColor (mm, i, index, r) {
      var color = (i === 13 && r ? 'b-L-GREY b-R-GREY b-T-GREY text-right' : 'b-L-GREY b-T-GREY text-right')
      if ((this.headers.length - 1) === index) {
        color += ' b-B-GREY'
      }
      return color
    },
    getStatus (group, month, metric, type, pa) {
      var value = 0
      if (!this.inout[group]) {
        return value
      }
      if (typeof this.inout[group][month - 1][metric.key] === 'undefined') {
        return value
      }
      return this.inout[group][month - 1][metric.key][type].length
    },
    getTotalStatus (group, metric, type) {
      var value = 0
      var a = 0
      if (!this.inout[group]) {
        return value
      }
      for (var x = 0; x < 12; x++) {
        var v = this.inout[group][x][metric.key][type].length
        a += v
      }
      return a
    },
    toggle (item, key) {
      var index = this.exp[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        this.exp[item][index].value = !this.exp[item][index].value
        if (key === 0) {
          for (var i in this.exp[item]) {
            this.exp[item][i].value = this.exp[item][index].value
          }
        }
      }
    },
    checkValue (item, i, index, metric) {
      if (metric.type === 'header' || metric.type === 'none') {
        return this.year === this.getFY() && this.mm === i ? this.pColor(item) : this.getWeekColor(1)
      }
      if (item === '*') {
        return 'transparent'
      }
      return 'transparent'
    },
    checkExpand (item, key) {
      if (typeof this.exp[item] === 'undefined') {
        return false
      }
      var index = this.exp[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        return this.exp[item][index].enable
      }
      return false
    },
    checkToggle (item, key) {
      if (typeof this.exp[item] === 'undefined') {
        return false
      }
      var index = this.exp[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        return this.exp[item][index].value
      }
      return false
    },
    checkHide (item, type) {
      if (typeof this.exp[item] === 'undefined') {
        return false
      }
      var index = this.exp[item].findIndex(expand => expand.type === type)
      if (index !== -1) {
        return !this.exp[item][index].value
      }
      return true
    },
    onChange (event, item, i, index, inout, metric) {
      this.$emit('onChange', { event: event, item: item, i: i, index: index, inout: inout, metric: metric })
    },
    onValueSelect (item, month, index, inout, metric) {
      this.$emit('onValueSelectStatus', { item: item, month: month, index: index, inout: inout, metric: metric })
    }
  }
}
</script>

<style scoped>
span.clickable {
  cursor: pointer !important;
}
.select-none {
  user-select: none;
}
.b-R {
  border-right: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L {
  border-left: 1px solid white !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T {
  border-top: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B {
  border-bottom: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-R-GREY {
  border-right: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L-GREY {
  border-left: 1px solid #80808080 !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T-GREY {
  border-top: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY {
  border-bottom: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
